module.exports = __webpack_public_path__ + "y.no1.21965de0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/y.no1.jpg
// module id = OWwq
// module chunks = 0